import { PublicClientApplication } from "@azure/msal-browser";
import { b2cConfig } from "./authConfig";

class MsalSingleton {
  private static instance: PublicClientApplication | null = null;

  public static getInstance(): PublicClientApplication {
    if (!MsalSingleton.instance) {
        MsalSingleton.instance = new PublicClientApplication(b2cConfig);
    }
    return MsalSingleton.instance;
  }
}

export const b2cInstance = MsalSingleton.getInstance();
